import { addOpenhome } from '@store/index'
import { useSetRecoilState, useRecoilValue } from 'recoil'
import { useCallback } from 'react'
import { assign } from 'lodash-es'
import { auctionDataLayer, openhomeDataLayer } from '@plugin/google/gtm/modules/property'

export default function useAddOpenhome() {

  const state = useRecoilValue(addOpenhome)
  const setOpenhomeState = useSetRecoilState(addOpenhome)


  // 添加openhome
  const showAddOpenhome = useCallback(({ openhome, signupSource = 'Add_Planner', house, online }) => {
    return event => {
      event.preventDefault()
      event.stopPropagation()
      openhomeDataLayer.click()
      openhomeDataLayer.show(online)
      setOpenhomeState(d => ({ ...d, show: true, auction: null, openhome, signupSource, house, online }))
    }
  }, [setOpenhomeState])

  // 添加auction
  const showAddAuction = useCallback(({ auction, signupSource = 'Add_Planner', house, online }) => {
    return event => {
      event.preventDefault()
      event.stopPropagation()
      auctionDataLayer.click()
      auctionDataLayer.show(online)
      setOpenhomeState(d => ({ ...d, show: true, openhome: null, auction, signupSource, house, online }))
    }
  }, [setOpenhomeState])

  // 切换openhome/auction loading
  const toggleLoading = useCallback(loading => {
    setOpenhomeState(d => {
      const { openhome, auction } = d
      if (auction) {
        return assign({ ...d, auctionLoading: loading }, loading ? { auctionSaved: true } : undefined)
      } else {
        return assign(
          { ...d, openhomeLoading: { ...d.openhomeLoading, [openhome.id]: loading } },
          loading ? { openhomeSaved: { ...d.openhomeSaved, [openhome.id]: true } } : undefined
        )
      }
    })
  }, [setOpenhomeState])

  // 隐藏添加openhome
  const hideAddOpenhome = useCallback(() => {
    setOpenhomeState(d => ({ ...d, show: false, openhome: null, auction: null, house: null, online: false, signupSource: null }))
  }, [setOpenhomeState])

  return {
    ...state,
    showAddOpenhome,
    showAddAuction,
    toggleLoading,
    hideAddOpenhome
  }
}